import _ from 'underscore';
import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import {
	getEntityUrl,
	getImageUrl
} from '@culture/common-helpers/cultureUtils';
import { getNumericDeclension } from '@culture/common-helpers/string';
import { broadcastTypePluralTitlesHash } from '@culture/utils/helpers/broadcast';

import { ImageFormatContext } from 'contexts/ImageFormatContext';
import Breadcrumbs from 'components/Breadcrumbs';
import Container from 'components/Container';
import GroupElements from 'components/GroupElements';
import LazyLoadImage from 'components/LazyLoad/Image';
import Tag from 'components/Tag';

import CommonPropTypes from 'utils/propTypes/common';

// import SubscribeButton from '../SubscribeButton';

import styles from './styles.module.scss';

const MainSection = ({ data, breadcrumbs }) => {
	const { title, thumbnailFile, broadcastsTypes, broadcastsTotal } = data;
	const url = getEntityUrl('institutes', data);

	const breadcrumbsItems = useMemo(
		() =>
			[
				{
					title: 'Культурный стриминг',
					path: 'live'
				}
			].concat(breadcrumbs),
		[breadcrumbs]
	);

	const imageFormat = useContext(ImageFormatContext);
	const imageSrc = getImageUrl(thumbnailFile, {
		format: imageFormat,
		params: {
			height: 474,
			width: 770,
			crop: 'fill',
			gravity: 'center'
		}
	});

	return (
		<Container>
			<div className={styles.head}>
				<Breadcrumbs items={breadcrumbsItems} />
			</div>
			<div className={styles.body}>
				<div className={styles.thumbnail}>
					<LazyLoadImage imageSrc={imageSrc} className={styles.imageWrapper}>
						<img src={imageSrc} alt="" className={styles.image} />
					</LazyLoadImage>
				</div>
				<div className={styles.content}>
					<h1 className={styles.title}>{title}</h1>
					{!_.isEmpty(broadcastsTypes) && (
						<GroupElements className={styles.tags}>
							{_(broadcastsTypes).map((type) => (
								<Tag
									key={type}
									title={broadcastTypePluralTitlesHash[type]}
									url={`/archive/type-${type}`}
									theme="bright"
								/>
							))}
						</GroupElements>
					)}
					{!!broadcastsTotal && (
						<div className={styles.count}>
							{broadcastsTotal}{' '}
							{getNumericDeclension(broadcastsTotal, {
								many: 'онлайн-событий',
								single: 'онлайн-событие',
								some: 'онлайн-события'
							})}
						</div>
					)}
					<div className={styles.more}>
						<a className={styles.moreLink} href={url}>
							Подробнее об учреждении
						</a>
					</div>
					{/* <div className={styles.buttonWrapper}> */}
					{/*	<SubscribeButton entity={data} /> */}
					{/* </div> */}
				</div>
			</div>
		</Container>
	);
};

MainSection.propTypes = {
	data: PropTypes.shape({
		_id: PropTypes.number.isRequired,
		title: PropTypes.string.isRequired,
		thumbnailFile: PropTypes.object.isRequired,
		mainRubric: PropTypes.shape({
			title: PropTypes.string.isRequired,
			path: PropTypes.string.isRequired
		}).isRequired,
		broadcastsTypes: PropTypes.array,
		broadcastsTotal: PropTypes.number
	}).isRequired,
	breadcrumbs: CommonPropTypes.breadcrumbs.isRequired
};

export default MainSection;
